function authGuardRoute(to, from, next) {
  var isAuthenticated = false;
  //this is just an example. You will have to find a better or 
  // centralised way to handle you localstorage data handling 
  var getAuth = localStorage.getItem('IsAuthenticated');
  if (getAuth === null) { isAuthenticated = false; }

  if (getAuth) {
    next();
  }
  else {
    next('/login')
  }

}

let rolesAccess = [];

function roleGuardRoute(to, from, next) {
  var getAuth = localStorage.getItem('IsAuthenticated');
  let user = JSON.parse(localStorage.getItem('UserRoles')) //get userRoles
  let menuList = JSON.parse(localStorage.getItem('menuList')) //get userMenus
  const profile = menuList.filter((p) => p.name === "profile" || p.name === "customerClub"); //get profile menus)

  const userProfileMenus = [];  // get profile path
  if (profile[0] != undefined) {
    profile[0].children.forEach((element) => {
      userProfileMenus.push(element.path.toLowerCase());
    });
  }
  const lacksRole = to.matched.some(route => {
    rolesAccess = user.filter(p => route.meta.roles.includes(p))
    return route.meta.roles
  })

  // check accessibility rout  
  if (lacksRole && (rolesAccess.length <= 0 || getAuth === null || userProfileMenus.filter(p => p.includes(to.fullPath.toLowerCase())).length <= 0)) {
    // localStorage.clear()
    alert('شما به این بخش دسترسی ندارین!!!')
    return next('/')  // Aborts the navigation request
  }
  next()
}
export default [
  {
    path: '',
    name: '',
    beforeEnter: roleGuardRoute,
    component: () => import("@/components/profile/ProfileDashboard"),

  },
  {
    path: 'dashboard',
    name: 'dashboard',
    beforeEnter: roleGuardRoute,
    component: () => import("@/components/profile/ProfileDashboard")
  },

  {
    path: 'personalInfo',
    name: 'personalInfo',
    beforeEnter: roleGuardRoute,
    component: () => import("@/components/profile/PersonalInfoTabs")
  },
  {
    path: 'userBusinessList',
    name: 'userBusinessList',
    beforeEnter: roleGuardRoute,
    component: () => import("@/components/profile/UserBusinessList")
  },
  {
    path: 'business/:sourceId?/:sourceProfileId?/:sourceType?',
    name: 'business',
    beforeEnter: authGuardRoute,
    component: () => import("@/components/profile/Business")
  },
  {
    path: 'counters',
    name: 'counters',
    beforeEnter: roleGuardRoute,
    component: () => import("@/views/profile/pages/CounterList")
  },
  {
    path: 'createCounter',
    name: 'createCounter',
    beforeEnter: authGuardRoute,
    component: () => import("@/views/profile/pages/CreateCounter")
  },
  {
    path: 'flightreports',
    name: 'flightreports',
    beforeEnter: roleGuardRoute,
    component: () => import("@/components/profile/reports/FlightReportTabs")
  },
  {
    path: 'hotelreports',
    name: 'hotelreports',
    beforeEnter: roleGuardRoute,
    component: () => import("@/components/profile/reports/hotelReports/HotelReportTabs")
  },
  {
    path: 'tourismreports/dolphin',
    name: 'tourismreports',
    beforeEnter: roleGuardRoute,
    component: () => import("@/components/profile/reports/tourismReports/DolphinReportTabs")
  },
  {
    path: 'tourismreports/fastTrack',
    name: 'tourismreports',
    beforeEnter: roleGuardRoute,
    component: () => import("@/components/profile/reports/tourismReports/FastTrackReportTabs")
  },
  {
    path: 'hotelflightreports',
    name: 'hotelflightreports',
    beforeEnter: roleGuardRoute,
    component: () => import("@/components/profile/reports/hotelFlightReports/HotelFlightTabs")
  },
  {
    path: 'tourism/:tourismType',
    name: 'tourism',
    beforeEnter: roleGuardRoute,
    component: () => import("@/views/profile/pages/tourism/TourismTabs"),
  },
  {
    path: 'hotel',
    name: 'hotel',
    beforeEnter: roleGuardRoute,
    component: () => import("@/views/profile/pages/hotel/HotelTabs"),
  },
  {
    path: "printhotelbooking/:id",
    name: "printhotelbooking",
    component: () => import("@/components/profile/reports/hotelReports/PrintHotelBooking")
  },
  {
    path: "printcustomerhotelbooking/:id",
    name: "printcustomerhotelbooking",
    component: () => import("@/components/profile/reports/hotelReports/PrintCustomerHotelBooking")
  },
  {
    path: "printHotelFlightBook/:id",
    name: "printHotelFlightBook",
    component: () => import("@/components/profile/reports/hotelFlightReports/PrintHotelFlightVoucher")
  },
  {
    path: "printCustomerFastTrackBook/:id",
    name: "printCustomerFastTrackBook",
    component: () => import("@/components/profile/reports/tourismReports/PrintCustomerFastTrackBook")
  },
  {
    path: "printAgencyFastTrackBook/:id",
    name: "printAgencyFastTrackBook",
    component: () => import("@/components/profile/reports/tourismReports/PrintAgencyFastTrackBook")
  },
  {
    path: "bankPaymentSuccess/:deposit",
    name: "bankPaymentSuccess",
    component: () => import("@/views/profile/pages/tourism/TourismBankPaymentSuccess")
  },
  {
    path: "bankPaymentError/:errorMessage",
    name: "bankPaymentError",
    component: () => import("@/views/profile/pages/tourism/TourismBankPaymentError")
  },
  {
    path: "scores",
    name: "scores",
    beforeEnter: roleGuardRoute,
    component: () => import("@/views/profile/pages/Scores")
  },
  {
    path: "survey",
    name: "survey",
    beforeEnter: roleGuardRoute,
    component: () => import("@/views/profile/pages/Survey")
  },
  { path: "**", redirect: "/" },


];
